import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '../shared/Header';
import MeetingSDK from '../MeetingSDK';
import HomeIcon from '../../assets/icons/home.svg';
import './Consultation.css';
import { usePodData } from '../../hooks/usePodData';
import Loader from '../shared/Loader';
import { useLocalization } from '../../context/LocalizationContext';
import { sendConsultationEmails } from '../../utils/api';
import { useUserData } from '../../hooks/useUserData';
import { usePodIP } from '../../hooks/usePodIP';
const Consultation = ({ userData }) => {
  const navigate = useNavigate();
  const { podIP } = usePodIP();
  const { t } = useLocalization();
  const [showVideoCall, setShowVideoCall] = useState(true);
  const [emailsSent, setEmailsSent] = useState(false);
  const [isEndingMeeting, setIsEndingMeeting] = useState(false);

  const { userData: userDataFromHook } = useUserData();

  const { podData, isLoadingPod, podError, loadPodData, refreshPodData } = usePodData();

  useEffect(() => {
    if (podIP) {
      loadPodData(podIP);
    }
  }, [podIP]);


  const handleCallError = (error) => {
    setShowVideoCall(false);
  };

  const handleMeetingJoined = async () => {
    if (!emailsSent && userDataFromHook?.patientId && podIP) {
      try {
        // console.log('Sending consultation emails...');
        await sendConsultationEmails(podIP, userDataFromHook.patientId);
        setEmailsSent(true);
        // console.log('Consultation emails sent successfully');
      } catch (error) {
        // console.error('Failed to send consultation emails:', error);
      }
    }
  };

  const handleEndMeeting = async () => {
    setIsEndingMeeting(true);
    navigate("/dashboard");
  };
  return (
    <div className="main-container">
      <Header
        text={t('consultation.title')}
        userData={userData}
      />

      <div className="consultation-video-container">
        {isEndingMeeting &&
          <Loader text={t('consultation.endingMeeting')} />
        }

        {!isEndingMeeting && isLoadingPod && (
          <Loader text={t('consultation.preparing')} />
        )}

        {!isEndingMeeting && !isLoadingPod && podError && (
          <div className="consultation-error">
            {t('consultation.connectionError')}
            <button
              onClick={() => refreshPodData(podIP)}
              disabled={isLoadingPod}
              className="footer-btn retry-btn"
            >
              {t('consultation.retry')}
            </button>
          </div>
        )}

        {!podError && !isLoadingPod && !isEndingMeeting && podData?.meetingLink && (
          <MeetingSDK
            roomUrl={podData?.meetingLink}
            onError={handleCallError}
            onCallEnd={handleMeetingJoined}
            userData={userData}
          />
        )}
      </div>

      <div className="assessment-footer">
        <button
          className="footer-btn home-btn"
          onClick={() => navigate("/dashboard")}
        >
          <img src={HomeIcon} alt="Home" />
        </button>
        <button
          className="footer-btn end-session-btn"
          onClick={handleEndMeeting}
          disabled={isLoadingPod || isEndingMeeting}
        >
          {isEndingMeeting
            ? t("consultation.endingMeeting")
            : t("consultation.endMeeting")}
        </button>
      </div>
    </div>
  );
};

export default Consultation;
